"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_ITEM_STATUS = void 0;
exports.ORDER_ITEM_STATUS = {
    ACTIVE: 'ACTIVE',
    DELETED: 'DELETED',
    DISPATCHED: 'DISPATCHED',
    HOLD: 'HOLD',
    RESOLVED: 'RESOLVED'
};
//# sourceMappingURL=orderItemStatus.js.map